'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getLastDigit = require('./getLastDigit');

var _getLastDigit2 = _interopRequireDefault(_getLastDigit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (ticks, pips) {
    return ticks.reduce(function (acc, x) {
        var digit = (0, _getLastDigit2.default)(x.quote, pips);
        acc[digit]++;
        return acc;
    }, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]).map(function (x) {
        return ticks.length && x / ticks.length * 100;
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/number/calculateLastDigitStats.js
// module id = 101
// module chunks = 0